import { useContext } from 'react';
import { useForm } from 'react-hook-form';
import { LoadingContext } from '../../../context/Loading/LoadingContext';
import { useApi } from '../../../hooks/userApi';
import React from 'react';
import { zodResolver } from '@hookform/resolvers/zod';
import ButtonPrimary from 'components/Buttons/ButtonPrimary/ButtomPrimary.component';
import TextInputField from 'components/inputs/TextField/TextField.component';
import { ContainerInternoWrapper, ContainerWrapper, FormGlobal } from 'styles/Global.styles';
import { useScreenSize, maskInput, validateEmail } from 'utils/helpers';
import { z } from 'zod';
import { FormLead } from '@typings/cadastro';
import { colors } from 'utils/colors';

const DetalhesCliente = () => {
  const { setLoading, setLoadingMensagem, setLoadingBtn, setLoadingAction }: any = useContext(LoadingContext);
  const isBreak = useScreenSize(570);

  const api = useApi();
  const schema = z.object({
    nome: z.string().nonempty({ message: 'O nome é obrigatório.' }),
    email: z
      .string()
      .optional()
      .refine(
        (value) => {
          if (!value || validateEmail(value)) {
            return true;
          } else {
            return false;
          }
        },
        { message: 'O email é inválido' },
      ),
    telefone: z.string().nonempty('O telefone é obrigatório.'),
  });

  const { clearErrors, handleSubmit, setValue, formState, watch } = useForm({
    defaultValues: {
      nome: '',
      email: '',
      telefone: '',
    },
    resolver: zodResolver(schema),
  });

  function handleChange(name: FormLead, event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) {
    const value = event.target.value;
    setValue(name, value);

    if (formState.errors[`${name}`]) {
      clearErrors(name);
    }
  }

  const onSubmit = async (data) => {
    setLoading(true);
    // data.vendedor = JSON.parse(sessionStorage.getItem("user"));
    try {
      data.cpfCNPJ = 'lead';
      data.vendedor = JSON.parse(sessionStorage.getItem('user'));
      const resposta = await api.post('cliente/lead', data);
      if (resposta.status === false) {
        setLoadingMensagem(resposta.mensagem);
        setLoadingBtn('OK');
      } else {
        setLoadingMensagem('Lead cadastrado com sucesso.');
        setLoadingAction('/vendedor/listLead');
        setLoadingBtn('OK');
      }
    } catch (e) {
      let msg = 'Houve um erro interno, tente mais tarde. ' + e.message;
      if (e.response.data.message === 'Unauthorized') {
        msg = 'Usuário não autorizado';
        setLoadingAction('/admin/sair');
      }

      setLoadingMensagem(msg);
      setLoadingBtn('OK');
    }
  };

  const dadosForm = [
    { label: 'Nome do Cliente', type: 'text', campo: 'nome', select: false, option: [] },
    { label: 'E-mail', type: 'text', campo: 'email', select: false, option: [] },
    { label: 'Telefone', type: 'text', campo: 'telefone', select: false, option: [] },
  ];

  const isCampoInFormCliente = (campo: string): campo is FormLead => {
    return campo === 'nome' || campo === 'email' || campo === 'telefone';
  };

  return (
    <>
      <FormGlobal noValidate onSubmit={handleSubmit(onSubmit)} style={{ width: '100%' }}>
        {dadosForm &&
          dadosForm.map((dados, index) => (
            <>
              <TextInputField
                key={index}
                label={dados.label}
                type={dados.type}
                selected={dados.select}
                nome={dados.campo}
                dados={dados.option}
                mask={maskInput(dados.campo)}
                style={{ width: isBreak ? '100%' : '49%' }}
                value={isCampoInFormCliente(dados.campo) ? watch(dados.campo) : null}
                error={!!formState.errors[dados.campo]}
                helperText={formState.errors[dados.campo] ? formState.errors[dados.campo].message : ''}
                onChange={(nome) => (isCampoInFormCliente(dados.campo) ? handleChange(dados.campo, nome) : null)}
              />
            </>
          ))}
      </FormGlobal>
      <div style={{ marginTop: '30px' }}>
        <ButtonPrimary typeSubmit label={'finalizar cadastro'} onClick={handleSubmit(onSubmit)} />
      </div>
    </>
  );
};

const CadastroLead = () => {
  return (
    <ContainerWrapper>
      <ContainerInternoWrapper>
        <p style={{ color: colors.verde, fontSize: '1.25rem', fontWeight: 600 }}>DADOS DO LEAD</p>
        <DetalhesCliente />
      </ContainerInternoWrapper>
    </ContainerWrapper>
  );
};

export default CadastroLead;
